<template>
  <div>
    <div :is="item0.component" ref="dialog0" :params="item0.params"></div>
    <div :is="item1.component" ref="dialog1" :params="item1.params"></div>
    <div :is="item2.component" ref="dialog2" :params="item2.params"></div>
    <div :is="item3.component" ref="dialog3" :params="item3.params"></div>
    <div :is="item4.component" ref="dialog4" :params="item4.params"></div>
    <div :is="item5.component" ref="dialog5" :params="item5.params"></div>
    <div :is="item6.component" ref="dialog6" :params="item6.params"></div>
    <div :is="item7.component" ref="dialog7" :params="item7.params"></div>
    <div :is="item8.component" ref="dialog8" :params="item8.params"></div>
    <div :is="item9.component" ref="dialog9" :params="item9.params"></div>
  </div>
</template>
<script>

  import FlowComplete from '@/common/components/public-dialog/complete'
  import FlowReject from '@/common/components/public-dialog/reject'

  import flowTransmit from '@/common/components/public-dialog/transmit'
  import flowPlanned from '@/common/components/public-dialog/planned'
  import flowWorktrack from '@/common/components/public-dialog/worktrack'
  import flowWorktrackLi from '@/common/components/public-dialog/worktrackLi'
  import flowWorktrackTree from '@/common/components/public-dialog/worktrackTree'

  import flowVirtualog from '@/common/components/public-dialog/virtuallog.vue'
  import flowSecrecord from '@/common/components/public-dialog/secrecord'


  import tree from './components/tree.vue'
  import treeTable from './components/treeTable.vue'
  import page from './components/page.vue'
  import tableDialog from './components/table.vue'

  // import changeFormVersion from './change-form-version.vue'

  import userSelect from './form/user-select'
  import orgSelect from './form/org-select'
  import flowScriptSet from './flow-script-set';

  import processChartViewer from './process-chart-viewer';
  import transactionProcess from './transaction-process'

  import processInterfering from './process-interfering.vue';
  import urgeProcess from './urge-process'
  import turnProcess from './turnto-process'

  // import userRole from './user-role.vue'

  import blank from './blank'
  import normalForm from './form/form.vue'
  import flowForm from './form/form.vue'

  import processOperationRecord from './process-operationRecord'
  /* import processFormFieldMapping from './process-formFieldMapping'*/
  import viewPreview from './view-preview.vue'
  import viewSelect from './view-select.vue'
  import commentEdit from './comment-edit.vue'

  import attachment from './attachment.vue'
  import NtkoEditor from './ntko/ntko-editor'
  import OnLineEfileEdit from './ntko/ntko-editor';
  import NtkoAttachment from './ntko/ntko-attachment'

/*  import pageCode from './system/page.vue'
  import message from './system/message.vue'
  import systemService from './system/service.vue'

  import action from './system/action.vue'
  import exportCompInfo from './system/exportCompInfo.vue'
  import importCompInfo from './system/importCompInfo.vue'

  import importComp from './system/importComp.vue'
  import importAppComp from './system/importAppComp.vue'

  import transferLog from './set/data-transferLog'
  import transferItemLog from './set/data-transferItemLog'



  import compPage from '../../views/appModule/comp_widget/comp-page.vue'*/

  export default {
    name: 'mwPublicDialog',
    components: {
      FlowComplete,
      FlowReject,
      flowTransmit,
      flowPlanned,
      flowWorktrack,
      flowWorktrackLi,
      flowWorktrackTree,
      flowVirtualog,
      flowSecrecord,
      transactionProcess,
      urgeProcess,
      turnProcess,
      commentEdit,
      NtkoEditor,
      OnLineEfileEdit,
      NtkoAttachment,
      attachment,
      tree,
      treeTable,
      tableDialog,
      page,
      userSelect,
      orgSelect,

      /*pageCode,
      systemService,
      action,
      message,*/

      /*exportCompInfo,
      importCompInfo,
      importAppComp,
      importComp,*/

      // changeFormVersion,
      blank,
      normalForm,
      flowForm,
      viewPreview,
      viewSelect,
      processChartViewer,
      processInterfering,
      // userRole,
      // processFormFieldMapping,
      processOperationRecord,
      // transferLog,
      // transferItemLog,
      flowScriptSet,
      // compPage
    },
    data(){
      return {
        index:0,
        item0:{},
        item1:{},
        item2:{},
        item3:{},
        item4:{},
        item5:{},
        item6:{},
        item7:{},
        item8:{},
        item9:{},
      }
    },
    methods: {
      clear(){
        let me=this;
        for(let idx=0;idx<10;idx++){
          if(me.mwRef('dialog'+idx) && (me.mwLodash.keys(me.mwRef('dialog'+idx).$refs).length>0) && !me.mwRef('dialog'+idx).mwRef(me.mwLodash.keys(me.mwRef('dialog'+idx).$refs)[0]).visible){
            me['item'+idx]={component:'blank',params:{}};
          }
        }
      },
      showForm:function(data,callback){
        data.isNewCallback=true;
        return this.show("normalForm", data, callback);
      },
      showPage:function(data,func,secondfunc){
        return this.show("page",data,func,secondfunc);
      },
      show(name,data,func,secondfunc){
        let me=this;
        me.index=0;
        for(let idx=0;idx<10;idx++){
          if(me.mwRef('dialog'+idx) && (me.mwLodash.keys(me.mwRef('dialog'+idx).$refs).length>0) && !me.mwRef('dialog'+idx).mwRef(me.mwLodash.keys(me.mwRef('dialog'+idx).$refs)[0]).visible){
            me['item'+idx]={component:'blank',params:{}};
          }
        }
        me.$nextTick(function () {
          me.__nextNoVisible();
          me.mwLodash.debounce(
            async function () {
              me.mwApi.org.checkToken().then(v=>{
                if(v) {
                  if (func) {
                    data.func = func
                  }
                  if (secondfunc) {
                    data.secondfunc = secondfunc
                  }
                  me['item' + me.index] = {component: name, params: data}
                }
              })
            },
            2000,
            {leading: true, trailing: false})();
        });
      },
      __nextNoVisible(){
        let me=this;
        if(me.mwRef('dialog'+me.index) ){
          let refs=me.mwRef('dialog'+me.index).$refs;
          if(me.mwLodash.keys(refs).length>0 && me.mwRef('dialog'+me.index).mwRef(me.mwLodash.keys(refs)[0]).visible){
            me.index++;
            me.__nextNoVisible();
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/index-rt.vue